import CartProductCard from '@Components/CartPage/CartProductCard';
import { LOGIN_REDIRECT } from '@Constants/index';
import { useAuth } from '@Contexts/AuthContext/Auth.context';
import usePrice from '@Hooks/usePrice';
import groupBy from 'lodash/groupBy';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useCookie } from 'react-use';
import { RootState } from 'store';
import { UserCart } from 'types/Cart';
import PartsList from '../PartsList';
import { Amount, CheckoutBtn, Content, Header, HeaderActions, HeaderInfo, List, Price } from './CartList.styled';

type Props = {};

export default function CartListSection({}: Props) {
  const { data: cartData } = useSelector((state: RootState) => state.cart);
  const { t } = useTranslation('Cart');
  const { thePrice } = usePrice((cartData as UserCart)?.total_price.total);
  const { userData } = useAuth();
  const { push, query } = useRouter();
  const hasThirdpartyParam = query.hasOwnProperty('thirdparty');
  const [, updateCookieRedirect] = useCookie(LOGIN_REDIRECT);
  const filteredCartData = groupBy(cartData?.items, (item) => item.product.car_str);
  const filteredCartKeys = useMemo(() => {
    const theKeys = Object.keys(filteredCartData);
    theKeys.push(theKeys.splice(theKeys.indexOf('null'), 1)[0]);
    return theKeys;
  }, [filteredCartData]);

  return (
    <List>
      <Header>
        <HeaderInfo>
          <p>{t('total')}</p>
          <Amount>
            ({cartData?.items.length} {t('orders')})
          </Amount>
        </HeaderInfo>
        <HeaderActions>
          <Price>{thePrice}</Price>
          <CheckoutBtn
            onClick={() => {
              if (Boolean(userData)) {
                push(hasThirdpartyParam ? '/checkout?thirdparty' : '/checkout');
              } else {
                push('/auth/login').then(() => {
                  updateCookieRedirect(
                    JSON.stringify({
                      asPath: '/checkout',
                      pathname: '/checkout',
                    })
                  );
                });
              }
            }}
          >
            {t('continue')}
          </CheckoutBtn>
        </HeaderActions>
      </Header>
      <Content>
        {Boolean(cartData?.items?.length) &&
          filteredCartKeys.map((key, i) => {
            if (key === 'null') {
              return filteredCartData[key]?.map((product) => <CartProductCard data={product} key={product.id} />);
            } else {
              return <PartsList car_str={key} items={filteredCartData[key]} />;
            }
          })}
      </Content>
    </List>
  );
}
